var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveContextData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 29.5C4.12 29.5 3 28.38 3 27C3 25.62 4.12 24.5 5.5 24.5C6.07 24.5 6.58 24.68 7 25V9.5H29V29.5",
    fill: "#8E8E98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.04 11.67L11.39 29.31L16.58 29.26L20.5 25.34L24.46 29.3H28.84V28.38L23.15 22.69L28.87 16.97L29.04 11.67Z",
    fill: "#363C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27V7C3 5.62 4.12 4.5 5.5 4.5C6.07 4.5 6.58 4.68 7 5V25C6.58 24.68 6.07 24.5 5.5 24.5C4.12 24.5 3 25.62 3 27Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 30H5.5C3.85 30 2.5 28.65 2.5 27V7C2.5 5.35 3.85 4 5.5 4C6.16 4 6.78 4.21 7.3 4.6L7.5 4.75V26.01L6.7 25.4C6.36 25.14 5.94 25 5.5 25C4.4 25 3.5 25.9 3.5 27C3.5 28.1 4.4 29 5.5 29H28.5V10H25.67V9H29.5V30ZM5.5 5C4.4 5 3.5 5.9 3.5 7V24.77C4.27 24.08 5.48 23.81 6.5 24.17V5.27C6.2 5.1 5.86 5 5.5 5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.49 28.73L22.44 22.69L28.51 16.62L29.22 17.33L23.86 22.69L29.19 28.02L28.49 28.73Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.11 29.66L20.5 26.05L16.94 29.61L16.23 28.9L20.5 24.63L24.82 28.95L24.11 29.66Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 11.3027L11.0381 28.9521L11.7452 29.6592L29.3946 12.0098L28.6875 11.3027Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 9.22H7V10.22H10.42V9.22Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.02 5.03001C19.8 2.81001 16.2 2.81001 13.98 5.03001C11.76 7.25001 11.76 10.85 13.98 13.07L18 17.09L22.02 13.07C24.24 10.85 24.24 7.25001 22.02 5.03001Z",
    fill: "#F36F4B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.8L13.63 13.43C12.46 12.26 11.82 10.71 11.82 9.06001C11.82 7.41001 12.46 5.86 13.63 4.69C14.8 3.52 16.35 2.88 18 2.88C19.65 2.88 21.2 3.52 22.37 4.69C23.54 5.86 24.18 7.41001 24.18 9.06001C24.18 10.71 23.54 12.26 22.37 13.43L18 17.8ZM18 3.87C16.62 3.87 15.31 4.41 14.33 5.39C13.35 6.37 12.81 7.67001 12.81 9.06001C12.81 10.45 13.35 11.75 14.33 12.73L18 16.4L21.67 12.73C22.65 11.75 23.19 10.45 23.19 9.06001C23.19 7.67001 22.65 6.37 21.67 5.39C20.69 4.41 19.39 3.87 18 3.87Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.39H15.5V10.63H16.5V8.39Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.39H17.5V10.63H18.5V6.39Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.39H19.5V10.63H20.5V7.39Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveContextData);
export default __webpack_public_path__ + "static/media/ActiveContextData.042dddc25265831a484142146b1db21c.svg";
export { ForwardRef as ReactComponent };